import { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Button, Form, Input, Modal, App } from "antd";
import { login } from "../redux/slice/userslice";
import { POST } from "../utils/apicalls";
import Logo from "../assets/logo.png";
import { API } from "../config/api";
import "../loginadmin/login.css";
import RegisterClient from "./registerclient";

const Loginclient = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isModalVisible2, setIsModalVisible2] = useState(false);
  const [form] = Form.useForm();
  const { notification } = App.useApp(); // Get notification from App context

  const onFinish = async (values: any) => {
    try {
      setLoading(true);
      const obj = {
        clientUsername: values.clientUsername,
        clientPassword: values.clientPassword,
        clientType: "client",
      };

      const url = API.CLIENT_LOGIN;

      const { data, status, message }: any = await POST(url, obj);

      if (status) {
        notification.success({ message });
        dispatch(login(data));
        localStorage.setItem("user", JSON.stringify(data));

        navigate("/client/clientdashboard");
      } else {
        notification.error({ message });
      }
    } catch (error) {
      console.error("Login failed:", error);
      notification.error({ message: "Login failed. Please try again." });
    } finally {
      setLoading(false);
    }
  };



  const handleUpdatePassword = async () => {
    try {
      const values = await form.validateFields();
      let { clientUsername, currentPasswords, newPasswords } = values;

      const { status, message }: any = await POST(API.UPDATE_CLIENT_PASSWORD, {
        clientUsername,
        currentPasswords,
        newPasswords
      });

      if (status) {
        notification.success({ message: "Password updated successfully." });
      } else {
        notification.error({ message });
      }
    } catch (error) {
      console.error("Password update failed:", error);
      notification.error({ message: "Failed to update password. Try again." });
    } finally {
      setIsModalVisible(false);
    }
  };

  return (
    <div className="loginScreen">
      <div className="backgroundOverlays"></div>
      <div className="loginContainer">
        <img src={Logo} alt="logo" className="loginLogo" />
        <div className="loginScreen-txt1">Login and Continue</div>

        <Form onFinish={onFinish} layout="vertical">
          <Form.Item
            label="Email or Username"
            name="clientUsername"
            rules={[{ required: true, message: "Required" }]}
          >
            <Input placeholder="Enter your username" size="large" />
          </Form.Item>

          <Form.Item
            label="Password"
            name="clientPassword"
            rules={[{ required: true, message: "Required" }]}
          >
            <Input.Password placeholder="Enter your password" size="large" />
          </Form.Item>

          <div className="forgotPassword">
            <span onClick={() => setIsModalVisible(true)}>
              Forgot Password?
            </span>
          </div>
          <div>
            <span onClick={() => setIsModalVisible2(true)}>
              are you new Register on it
            </span>
          </div>

          <Button
            block
            size="large"
            htmlType="submit"
            type="primary"
            loading={loading}
          >
            Sign In
          </Button>
        </Form>
      </div>

      {/* Forgot Password Modal */}
      <Modal
        title="Update Password"
        open={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        onOk={handleUpdatePassword}
        okText="Update Password"
      >
        <Form form={form} layout="vertical">
          <Form.Item
            label="Enter your Username"
            name="clientUsername"
            rules={[{ required: true, message: "Please enter your Username" }]}
          >
            <Input placeholder="Enter your username" />
          </Form.Item>

          <Form.Item
            label="Old Password"
            name="currentPasswords"
            rules={[
              { required: true, message: "Please enter your old password" },
              { min: 6, message: "Password must be at least 6 characters" },
            ]}
          >
            <Input.Password placeholder="Enter old password" />
          </Form.Item>
          <Form.Item
            label="New Password"
            name="newPasswords"
            rules={[
              { required: true, message: "Please enter your new password" },
              { min: 6, message: "Password must be at least 6 characters" },
            ]}
          >
            <Input.Password placeholder="Enter new password" />
          </Form.Item>
        </Form>
      </Modal>

      <Modal
        open={isModalVisible2}
        onCancel={() => setIsModalVisible2(false)}
        footer={null} // Remove default buttons if needed
      >
        <RegisterClient onSuccess={() => setIsModalVisible2(false)} />
      </Modal>
    </div>
  );
};

export default Loginclient;
